var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 pt-4 scheduler-page",attrs:{"fluid":""}},[_c('v-row',{staticClass:"toolbar-row"},[_c('v-toolbar',{staticClass:"default-toolbar",attrs:{"flat":"","fixed":""}},[_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}})],1)],1),_c('v-row',{staticClass:"scheduler-row"},[_c('Calendar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }